import Cookies from "js-cookie";
import type {
	ConsentChoice,
	CookieConsentStatus,
} from "@/@types/cookie-consent";

const COOKIE_NAME = "cookieConsent";
const COOKIE_EXPIRY_DAYS = 365;

/**
 * Get the current cookie consent status
 */
export function getCookieConsent(): ConsentChoice {
	const consent = Cookies.get(COOKIE_NAME);
	if (!consent) return null;
	return consent as ConsentChoice;
}

/**
 * Set cookie consent status
 */
export function setCookieConsent(choice: "accepted" | "declined"): void {
	const consentData: CookieConsentStatus = {
		accepted: choice === "accepted",
		timestamp: Date.now(),
	};

	Cookies.set(COOKIE_NAME, choice, {
		expires: COOKIE_EXPIRY_DAYS,
		path: "/",
		sameSite: "Lax",
		secure: process.env.NODE_ENV === "production",
	});

	// Trigger custom event for other parts of the app to react
	window.dispatchEvent(
		new CustomEvent("cookieConsentChanged", {
			detail: { choice, data: consentData },
		}),
	);
}

/**
 * Remove cookie consent (for testing/reset purposes)
 */
export function removeCookieConsent(): void {
	Cookies.remove(COOKIE_NAME, { path: "/" });
}

/**
 * Check if user has accepted cookies
 */
export function hasAcceptedCookies(): boolean {
	return getCookieConsent() === "accepted";
}

/**
 * Initialize analytics and tracking scripts when cookies are accepted
 */
export function initializeTracking(): void {
	if (hasAcceptedCookies()) {
		// Initialize your tracking scripts here
		// Example: Google Analytics, Facebook Pixel, etc.
		console.log("Tracking initialized");

		// Add your tracking initialization code here
		// if (typeof window !== 'undefined' && window.gtag) {
		//   window.gtag('consent', 'update', {
		//     analytics_storage: 'granted'
		//   });
		// }
	}
}
